import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { Form as EditForm } from './edit_form'
import { EditShiftQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const { data, loading } = useQuery<EditShiftQuery>(Query, { variables: { filters: { idEq: id } } })

  return (
    <>
      <Dialog open={open} size="3xl" onClose={setOpen}>
        <DialogTitle>
          <div>
            {
              loading || !data
                ? <Loading />
                : `${data?.shifts.nodes[0].user?.name || 'Unassigned shift'}
                   (${data?.shifts.nodes[0].event.description})`
            }
          </div>
        </DialogTitle>
        <DialogBody>
          <EditForm id={id} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
